import React, { useEffect, useState } from 'react';
import { ApiService } from '../../utils/ApiService';
import Pagination from '../../common/Pagination';
import { Avatar, formatDateTime } from '../../common/Functions';
import { showToast } from '../../common/Toast';
import ChartContainer from '../../components/ChartContainer';
import { useNavigate } from 'react-router-dom';
import { capitalizeEachWord } from '../../utils/common';
import FullPageLoader from '../../common/FullPageLoader';

const StatCard = ({ title, value, tracker, color }) => (
    <div className={`bg-white p-5 rounded-xl shadow-sm `}>
        <p className="text-[16px] text-black-500 font-medium mb-1">{title}</p>

        <h3 className="text-[40px] font-semibold" style={{ color, fontWeight: 700 }}>
            {value}
        </h3>

        <p className="text-[14px] text-[#4C4C4C] mt-1">{tracker}</p>
    </div>
);

const Dashboard = () => {

    const navigate = useNavigate();
    const [dataCount, setDataCount] = useState({});
    const [events, setEvents] = useState([]);
    const [pagination, setPagination] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [bookingGraph, setBookingGraph] = useState({});
    const [loading, setLoading] = useState(false);

    const getDashboardData = async () => {
        const res = await ApiService.get('admin/dashboard');
        if (res.success) {
            setDataCount(res.data)
        }
    }

    const getBookingsGraphData = async () => {
        const res = await ApiService.get('admin/booking-graph');
        if (res.success) {
            setBookingGraph(res.data)
        }
    }

    const getEventsList = async (currentPage, currentLimit) => {
        try {
            setLoading(true)
            const params = {
                page: currentPage,
                limit: currentLimit
            }
            const res = await ApiService.get(`admin/event-list?page=${params.page}&limit=${params.limit}`);
    
            if (res.success) {
                console.log("EVENTS --> ",res)
                setEvents(res.events);
                setPagination(res.pagination);
                setLoading(false)
            }
        } catch (error) {
            console.log("Error while fetching Attendee Data --> ", error)
        }
    }

    useEffect(() => {
        getDashboardData();
        getBookingsGraphData()
    }, []);

    useEffect(() => {
        getEventsList(page, limit);
    }, [page, limit])

    // Handler for pagination buttons
    const handlePagination = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            setPage(newPage);
        }
    }
    // const handleStatus = async (id, status) => {
    //     try {
    //         let params = {
    //             "userId": id,
    //             "status": !status
    //         }
    //         const res = await ApiService.post(`admin/enable-disable-user`, params)
    //         console.log(res)
    //         if (res.success) {
    //              showToast.success(res.message)
    //             getEventsList(page, limit)
    //         } else {
    //             showToast.error(res.message)
    //         }
    //     } catch (error) {

    //     }
    // };

    const handleStatus = async (id, status) => {
        try {
          let params = {
            eventId: id,
            enableStatus: !status,
          };
          const res = await ApiService.post(`/admin/enable-disable-event`, params);
          console.log(res);
          if (res.success) {
            showToast.success(res?.message);
            getEventsList(page, limit);
          } else {
            showToast.error(res.message);
          }
        } catch (error) {
          console.log("hanle status error", error);
        }
    };

    const startingIndex = (page - 1) * limit;

    return (
        <div className="flex-grow overflow-auto">
            
            {loading && <FullPageLoader />}

            <main className="px-6 pb-6 space-y-6 overflow-auto h-[90vh] bg-gray-100 scrollbar-hide">

                {/* Top Stats Row */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    <StatCard
                        title="Active Events"
                        value={dataCount?.events || 0}
                        tracker="Track all live events on platform."
                        color={'#1291C0'}
                    />
                    <StatCard
                        title="Total Host"
                        value={dataCount?.hostCount || 0}
                        tracker="View all active event hosts."
                        color={'#FF6200'}
                    />
                    <StatCard
                        title="Total Attendee"
                        value={dataCount?.attendeeCount || 0}
                        tracker="Monitor registered event attendees."
                        color={'#8F12C0'}
                    />
                    {/* Platform Commission Card (Green Border) */}
                    <StatCard
                        title="Platform Earnings"
                        value={ dataCount.totalPayments ? "$ "+ dataCount.totalPayments : "$ 0.00"}
                        tracker="View total platform earnings."
                        // isCommission={true}
                        color={'#4CAF50'}
                    />
                </div>

                {/* --- Charts Row --- (Unchanged) */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* <ChartContainer
                        title="Subscription"
                        totalCount="0"
                        chartColor="#3498DB"
                        chartLabel="Subscription Chart Placeholder"
                    /> */}
                    <ChartContainer
                        title="Bookings"
                        chartData={bookingGraph}
                        monthlyGraph={bookingGraph?.monthlyGraph || 0}
                        weeklyGraph={bookingGraph?.weeklyGraph || 0}
                        totalCount={dataCount?.bookingCount || 0}
                        chartColor="#4CAF50"
                        chartLabel="Bookings Chart Placeholder"
                    />
                </div>
                {/* --- Attendees Management Table --- */}
                <div>
                    <div className="flex justify-between items-center mb-3 px-2">
                        <div className="text-lg font-semibold text-gray-800">Event Management</div>
                        <button className="text-[#4C4C4C] font-large text-m hover:underline" onClick={()=>navigate("/event-management")}>see all</button>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm">

                        {/* Table Structure */}
                        <div className="overflow-x-auto rounded-xl">
                            <table className="min-w-full divide-y rounded-md divide-gray-200 ">
                                <thead className="bg-gray-200 text-black">
                                    <tr>
                                        {['Event Id', 'Date & Time', 'Host Name', 'Event Name', 'Total Interested', 'Total Engagement', 'Total Booking', 'Action'].map((header) => (
                                            <th 
                                                key={header}
                                                className={`p-4 font-normal ${
                                                header === "Actions" ? "text-center" : "text-left"
                                                }`}
                                            >
                                                {header}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {events.length > 0 ? (
                                        events.map((event, index) => (
                                            <tr key={event._id}>
                                                <td className="p-4 text-left text-[#4C4C4C] font-normal text-sm underline">#{event?._id?.slice(-6)}</td>

                                                <td className="p-4 text-left text-[#4C4C4C] font-normal text-sm">{formatDateTime(event?.startTime)}</td>

                                                <td className="p-4 flex items-center gap-2 text-[#4C4C4C] text-sm"> <Avatar
                                                    name={event?.host?.name}
                                                    image={event?.host?.image}
                                                />
                                                    {capitalizeEachWord(event?.host?.name) || "-"}
                                                </td>

                                                <td className="p-4 text-left text-[#4C4C4C] font-normal text-sm">{event.name || "N/A"}</td>

                                                <td className="p-4 text-left text-[#4C4C4C] font-normal text-sm">{event.interestedCount || "-"}</td>

                                                <td className="p-4 text-left text-[#4C4C4C] font-normal text-sm">{event.engagementCount || "-"}</td>

                                                <td className="p-4 text-center align-middle">
                                                    {/* <button
                                                        onClick={() => handleStatus(user._id, user.status)}
                                                        className={`relative inline-block w-8 h-4 rounded-full transition ${user.status ? "bg-green-500" : "bg-gray-300"
                                                            }`}
                                                    >
                                                        <span
                                                            className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition ${user.status ? "translate-x-4" : ""
                                                                }`}
                                                        ></span>
                                                    </button> */}
                                                    {event.bookingCount || "-"}
                                                </td>
                                                <td className="p-4 text-center align-middle">
                                                    <button 
                                                    disabled={event?.bookingCount > 0}
                                                        onClick={() =>
                                                        handleStatus(event._id, event.enableStatus)
                                                        }
                                                        className={`relative inline-block w-8 h-4 rounded-full transition ${
                                                        event.enableStatus ? "bg-green-500" : "bg-gray-300" 
                                                        } ${event?.bookingCount > 0 && " opacity-50 cursor-not-allowed"}`}
                                                    >
                                                        <span
                                                        className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition ${
                                                            event.enableStatus ? "translate-x-4" : ""
                                                        }`}
                                                        />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="px-6 py-4 text-center text-gray-500">No attendee data available.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </div>
                        {
                            pagination.totalPages > 1 && (
                                <Pagination
                                    page={page}
                                    totalPages={pagination.totalPages}
                                    totalItems={pagination.totalEvent}
                                    limit={limit}
                                    onPageChange={(newPage) => handlePagination(newPage)}
                                />
                            )}
                </div>

            </main>
        </div>
    );
};

export default Dashboard;